import React, { Component } from 'react';

import moment from 'moment';

import GoalsService from '../../services/GoalsService';

import GoalsViewHome from './GoalsViewHome';
import GoalsViewNew from './GoalsViewNew';
import GoalsViewInfo from './GoalsViewInfo';
import GoalsViewEdit from './GoalsViewEdit';
import GoalsViewResults from './GoalsViewResults';

export default class GoalsViewCentral extends Component {

    constructor(props) {
        super(props);

        this.goalsService = new GoalsService();

        this.state = {
            newGoalForm: {
                scope: 'ClientAccount',
                clientAccountId: '',
                locationId: null,
                userId: null,
                reportKPIId: null,
                name: '',
                useUnder: null,
                value: '',
                description: '',
                type: null,
                maxLevels: 999999999,
                timeFrame: null, //Week, Day,Month,Quarter, Year
                fromDate: null,
                toDate: null,
                createDate: null,
                createdBy: '',
                updateDate: null,
                updatedBy: '',
                isArchived: false
            },
            activeGoalForm: null
        }

        this.handleScroll = this.handleScroll.bind(this);

        this.convertToDateIndex = this.convertToDateIndex.bind(this);

        this.startNewGoal = this.startNewGoal.bind(this);
        this.cancelNewGoal = this.cancelNewGoal.bind(this);
        this.finishNewGoal = this.finishNewGoal.bind(this);
        this.editNewGoal = this.editNewGoal.bind(this);

        this.startEditGoal = this.startEditGoal.bind(this);
        this.cancelActiveGoal = this.cancelActiveGoal.bind(this);
        this.saveActiveGoal = this.saveActiveGoal.bind(this);
        this.editActiveGoal = this.editActiveGoal.bind(this);

        this.startResultsGoal = this.startResultsGoal.bind(this);

        this.organizeGoals = this.organizeGoals.bind(this);
    }

    componentDidMount() {

    }

    componentWillReceiveProps() {

    }

    componentWillUnmount() {

    }

    handleScroll(e) {
        this.props.handleScrollTop(e.target.scrollTop <= 0, e.target.scrollTop);
    }

    convertToDateIndex(date) {
        return parseInt(new moment(date).format('YYYYMMDD'));
    }

    startNewGoal() {

        let self = this;

        if (this.props.accountInfo != undefined) {

            this.setState({
                newGoalForm: {
                    scope: 'ClientAccount',
                    clientAccountId: this.props.accountInfo.clientAccountList[zzDataCache.settings.selectedClientAccountIndex].clientAccountId,
                    locationId: null,
                    userId: null,
                    reportKPIId: null,
                    name: '',
                    useUnder: null,
                    value: '',
                    description: '',
                    type: null,
                    maxLevels: 999999999,
                    timeFrame: null, //Week, Day,Month,Quarter, Year
                    fromDate: null,
                    toDate: null,
                    createDate: moment().format('MM/DD/YYYY'),
                    createdBy: this.props.accountInfo.userName,
                    updateDate: moment().format('MM/DD/YYYY'),
                    updatedBy: this.props.accountInfo.userName,
                    isArchived: false
                }
            }, () => {
                self.props.handleNavChange(undefined, 'new');
            });
        }
    }

    startEditGoal() {

        let self = this;

        if (this.props.accountInfo != undefined) {

            let goal = this.props.activeGoal;
            let scope = goal.userId != null ? 'User' : (goal.locationId != null ? 'Location' : 'ClientAccount');

            this.setState({
                activeGoalForm: {
                    goalId: goal.goalId,
                    scope: scope,
                    clientAccountId: goal.clientAccountId,
                    locationId: goal.locationId,
                    userId: goal.userId,
                    reportKPIId: goal.reportKPIId,
                    name: goal.name,
                    useUnder: goal.useUnder,
                    value: goal.value.toString(),
                    description: goal.description,
                    type: goal.type,
                    maxLevels: goal.maxLevels,
                    timeFrame: goal.timeFrame, //Week, Day,Month,Quarter, Year
                    fromDate: goal.fromDate,
                    toDate: goal.toDate,
                    createDate: goal.createDate,
                    createdBy: goal.createdBy,
                    updateDate: moment().format('MM/DD/YYYY'),
                    updatedBy: this.props.accountInfo.userName,
                    isArchived: goal.isArchived
                }
            }, () => {
                self.props.handleModeChange('edit');
            });
        }
    }

    startResultsGoal() {
        let self = this;

        if (this.props.accountInfo != undefined) {

            let goal = self.props.activeGoal;

            self.props.loadingOn();

            self.goalsService.getGoal(true, goal.goalId, goalData => {
                if (goalData.blastData.length > 0) {

                    this.props.handleAddGoalData(goalData);

                } else {
                    self.props.loadingOff();
                    alert("There are currently no valid results for this goal.");
                }
            }, err => {
                self.props.loadingOff();
                alert("There was an error getting goal results. Please try again.");
            });
        }
    }

    cancelNewGoal() {

        let self = this;

        this.setState({
            newGoalForm: {
                scope: 'ClientAccount',
                clientAccountId: '',
                locationId: null,
                userId: null,
                reportKPIId: null,
                name: '',
                useUnder: null,
                value: '',
                description: '',
                type: null,
                maxLevels: 999999999,
                timeFrame: null, //Week, Day, Month, Quarter, Year
                fromDate: null,
                toDate: null,
                createDate: null,
                createdBy: '',
                updateDate: null,
                updatedBy: '',
                isArchived: false
            }
        }, () => {
            self.props.handleNavChange(undefined, 'home');
        });
    }

    cancelActiveGoal() {
        let self = this;

        this.setState({ activeGoalForm: null }, () => {
            self.props.handleModeChange('home');
        });
    }

    finishNewGoal() {
        let self = this;
        let gForm = this.state.newGoalForm;

        let finalForm = {
            clientAccountId: gForm.clientAccountId,
            locationId: gForm.locationId,
            userId: gForm.userId,
            reportKPIId: gForm.reportKPIId,
            name: gForm.name,
            useUnder: gForm.useUnder,
            value: parseFloat(gForm.value),
            description: gForm.description,
            type: gForm.type,
            maxLevels: gForm.maxLevels,
            timeFrame: gForm.timeFrame,
            fromDate: gForm.fromDate,
            toDate: gForm.toDate,
            createDate: gForm.createDate,
            createdBy: gForm.createdBy,
            updateDate: gForm.updateDate,
            updatedBy: gForm.updatedBy,
            isArchived: gForm.isArchived
        }

        this.props.handleSave(finalForm, () => {
            self.setState({
                newGoalForm: {
                    scope: 'ClientAccount',
                    clientAccountId: '',
                    locationId: null,
                    userId: null,
                    reportKPIId: null,
                    name: '',
                    useUnder: null,
                    value: '',
                    description: '',
                    type: null,
                    maxLevels: 999999999,
                    timeFrame: null, //Week, Day, Month, Quarter, Year
                    fromDate: null,
                    toDate: null,
                    createDate: null,
                    createdBy: '',
                    updateDate: null,
                    updatedBy: '',
                    isArchived: false
                }
            });
        });
    }

    saveActiveGoal() {
        let self = this;
        let gForm = this.state.activeGoalForm;

        let finalForm = {
            goalId: gForm.goalId,
            clientAccountId: gForm.clientAccountId,
            locationId: gForm.locationId,
            userId: gForm.userId,
            reportKPIId: gForm.reportKPIId,
            name: gForm.name,
            useUnder: gForm.useUnder,
            value: parseFloat(gForm.value),
            description: gForm.description,
            type: gForm.type,
            maxLevels: gForm.maxLevels,
            timeFrame: gForm.timeFrame,
            fromDate: gForm.fromDate,
            toDate: gForm.toDate,
            createDate: gForm.createDate,
            createdBy: gForm.createdBy,
            updateDate: gForm.updateDate,
            updatedBy: gForm.updatedBy,
            isArchived: gForm.isArchived
        }

        this.props.handleSave(finalForm, () => {
            self.setState({
                activeGoalForm: null
            });
        });
    }

    editNewGoal(newGoalForm) {
        this.setState({ newGoalForm: newGoalForm });
    }

    editActiveGoal(activeGoalForm) {
        this.setState({ activeGoalForm: activeGoalForm });
    }

    organizeGoals() {
        let goalsObj = {
            active: {
                clientAccount: [],
                location: [],
                user: []
            },
            complete: {
                clientAccount: [],
                location: [],
                user: []
            },
            archive: []
        };

        this.props.goals.forEach((goal) => {
            // Archived
            if (goal.isArchived) {
                goalsObj.archive.push(goal);

                // Active
            } else if (this.convertToDateIndex(new Date(goal.toDate)) >= this.convertToDateIndex(new Date())) {

                if (goal.userId === null && goal.locationId === null) { // Client Account Goal
                    goalsObj.active.clientAccount.push(goal);
                } else if (goal.userId === null && goal.locationId != null) { // Location Goal
                    goalsObj.active.location.push(goal);
                } else if (goal.userId != null && goal.locationId != null) { // User Goal
                    goalsObj.active.user.push(goal);
                }

                // Completed
            } else {
                if (goal.userId === null && goal.locationId === null) { // Client Account Goal
                    goalsObj.complete.clientAccount.push(goal);
                } else if (goal.userId === null && goal.locationId != null) { // Location Goal
                    goalsObj.complete.location.push(goal);
                } else if (goal.userId != null && goal.locationId != null) { // User Goal
                    goalsObj.complete.user.push(goal);
                }
            }
        });

        goalsObj = {
            active: {
                clientAccount: _.sortBy(goalsObj.active.clientAccount, (goal) => { return goal.name }),
                location: _.sortBy(goalsObj.active.location, (goal) => { return goal.name }),
                user: _.sortBy(goalsObj.active.user, (goal) => { return goal.name })
            },
            complete: {
                clientAccount: _.sortBy(goalsObj.complete.clientAccount, (goal) => { return goal.name }),
                location: _.sortBy(goalsObj.complete.location, (goal) => { return goal.name }),
                user: _.sortBy(goalsObj.complete.user, (goal) => { return goal.name })
            },
            archive: _.sortBy(goalsObj.archive, (goal) => { return goal.name })
        };

        return goalsObj;
    }

    render() {

        let outerClass = "settings-sub-container";
        let outerStyle = this.props.style;
        if (this.props.mode === 'new' || this.props.mode === 'info' || this.props.mode === 'edit') {
            outerStyle.overflow = 'hidden';
        }


        let goalsObj = this.organizeGoals();

        let homeClass = 'gc-sub-container';
        let homeStyle = {};
        if (this.props.mode != 'home') {
            homeClass += ' gc-sub-container--forward';
        }

        let newClass = 'gc-sub-container';
        let newStyle = {};
        if (this.props.mode != 'new') {
            newClass += ' gc-sub-container--back';
        }

        let editClass = 'gc-sub-container';
        let editStyle = {};
        if (this.props.mode != 'edit') {
            editClass += ' gc-sub-container--back';
        }

        let infoClass = 'gc-sub-container';
        let infoStyle = {};
        if (this.props.mode != 'info') {
            infoClass += ' gc-sub-container--back';
        }

        let resultsClass = 'gc-sub-container';
        let resultsStyle = {};
        if (this.props.mode != 'results') {
            resultsClass += ' gc-sub-container--back';
        }


        if (this.props.accountInfo === undefined) {
            return (
                <div className={outerClass} style={outerStyle} onScroll={this.handleScroll}></div>
            );
        }

        return (
            <div className={outerClass} style={outerStyle} onScroll={this.handleScroll}>
                <GoalsViewHome
                    accountInfo={this.props.accountInfo}
                    users={this.props.users}
                    reportKPIs={this.props.reportKPIs}
                    className={homeClass}
                    style={homeStyle}
                    goals={this.props.goals}
                    goalsObj={goalsObj}
                    selectedGoalId={this.props.selectedGoalId}
                    handleSelectGoal={this.props.handleSelectGoal}
                    startNewGoal={this.startNewGoal}
                    startEditGoal={this.startEditGoal}
                    startResultsGoal={this.startResultsGoal}
                    handleDelete={this.props.handleDelete}
                    handleArchive={this.props.handleArchive}
                    handleGoalActiveMode={this.props.handleGoalActiveMode}
                    handleModeChange={this.props.handleModeChange}
                />
                {
                    this.props.isActive ? [
                        (<GoalsViewNew
                            accountInfo={this.props.accountInfo}
                            users={this.props.users}
                            reportKPIs={this.props.reportKPIs}
                            calendarDates={this.props.calendarDates}
                            className={newClass}
                            style={newStyle}
                            newGoalForm={this.state.newGoalForm}
                            editNewGoal={this.editNewGoal}
                            cancelNewGoal={this.cancelNewGoal}
                            finishNewGoal={this.finishNewGoal}
                        />),
                        (<GoalsViewEdit
                            accountInfo={this.props.accountInfo}
                            users={this.props.users}
                            reportKPIs={this.props.reportKPIs}
                            calendarDates={this.props.calendarDates}
                            className={editClass}
                            style={editStyle}
                            activeGoalForm={this.state.activeGoalForm}
                            editActiveGoal={this.editActiveGoal}
                            cancelActiveGoal={this.cancelActiveGoal}
                            saveActiveGoal={this.saveActiveGoal}
                        />),
                        (<GoalsViewInfo
                            accountInfo={this.props.accountInfo}
                            users={this.props.users}
                            reportKPIs={this.props.reportKPIs}
                            calendarDates={this.props.calendarDates}
                            className={infoClass}
                            style={infoStyle}
                            identity={this.props.activeGoal}
                        />),
                        (<GoalsViewResults
                            accountInfo={this.props.accountInfo}
                            users={this.props.users}
                            reportKPIs={this.props.reportKPIs}
                            calendarDates={this.props.calendarDates}
                            className={resultsClass}
                            style={resultsStyle}
                            identity={this.props.activeGoal}
                        />)
                    ]
                        : null
                }
            </div>
        )
    }
}